import { render } from "./WonScreen.vue?vue&type=template&id=a413d294"
import script from "./WonScreen.vue?vue&type=script&lang=js"
export * from "./WonScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__